import { apiFetch } from '../../shared/apiClient';

export interface CommitmentScoringSettings {
  profile: string;
  scopeWeight: number;
  scheduleWeight: number;
}

export interface CommitmentScoringOverride {
  productId: string;
  productName: string;
  settings: CommitmentScoringSettings;
}

export interface EffectiveCommitmentScoringSettings {
  settings: CommitmentScoringSettings;
  isOverride: boolean;
}

export const CommitmentScoringApi = {
  async getOrgSettings(): Promise<{ settings: CommitmentScoringSettings }> {
    const res = await apiFetch('/api/commitment/settings/org');
    if (!res.ok) throw new Error(`Failed to fetch org commitment settings: ${res.statusText}`);
    return res.json();
  },

  async getOverrides(): Promise<{ overrides: CommitmentScoringOverride[] }> {
    const res = await apiFetch('/api/commitment/settings/overrides');
    if (!res.ok) throw new Error(`Failed to fetch commitment overrides: ${res.statusText}`);
    return res.json();
  },

  async saveOrgSettings(
    settings: CommitmentScoringSettings
  ): Promise<{ settings: CommitmentScoringSettings }> {
    const res = await apiFetch('/api/commitment/settings/org', {
      method: 'PUT',
      body: JSON.stringify(settings),
    });
    if (!res.ok) throw new Error(`Failed to save org commitment settings: ${res.statusText}`);
    return res.json();
  },

  async saveOverride(
    productId: string,
    settings: CommitmentScoringSettings
  ): Promise<{ settings: CommitmentScoringSettings; isOverride: boolean }> {
    const res = await apiFetch(
      `/api/commitment/settings/overrides/${encodeURIComponent(productId)}`,
      {
        method: 'PUT',
        body: JSON.stringify(settings),
      }
    );
    if (!res.ok) throw new Error(`Failed to save commitment override: ${res.statusText}`);
    return res.json();
  },

  async deleteOverride(productId: string): Promise<void> {
    const res = await apiFetch(
      `/api/commitment/settings/overrides/${encodeURIComponent(productId)}`,
      { method: 'DELETE' }
    );
    if (!res.ok) throw new Error(`Failed to reset commitment override: ${res.statusText}`);
  },
};
